import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedRoute({ requiredUserType, loginPath, children }) {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || user.userType !== requiredUserType) {
    return <Navigate to={loginPath} replace />;
  }

  return children;
}
